import React from 'react';
import Text from '../../../../BaseModule/Components/Text';
import { useFamilyMemberInvitationDetailQuery } from '../../../../../graphql/graphql';
import netteApiClient from '../../../../../Services/NetteApiClient';
import { useAppContext } from '../../../../../Services/AppContext';
import Loading from '../../../../BaseModule/Components/Loading';

interface Props {
	userId: string;
	allowEdit?: boolean;
}

const UserFamilyMemberInvitation: React.FC<Props> = ({ userId, allowEdit }) => {
	const { data, isLoading } = useFamilyMemberInvitationDetailQuery({
		id: userId,
	});
	// @ts-ignore
	const { handleEditNette } = useAppContext();

	const userProfile = data?.user?.profile;

	const handleEdit = async () => {
		await netteApiClient.get(handleEditNette);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className='user-profile-card'>
			<div className='user-profile-card__header'>
				<div className='user-profile-card__header__title'>
					{userProfile?.fullName}
				</div>
				{allowEdit && (
					<div className='user-profile-card__header__controls'>
						<div
							className='user-profile-card__header__controls__icon-wrapper'
							onClick={handleEdit}
						>
							<i className='fa-solid fa-pencil'></i>
						</div>
					</div>
				)}
			</div>
			<div className='user-profile-card__body'>
				{userProfile?.birthDate && (
					<div className='user-profile-card__body__item'>
						<Text
							className='user-profile-card__body__item__label'
							tx='base.shared.dateOfBirth'
							firstUpper
						/>
						<div className='user-profile-card__body__item__value'>
							{userProfile?.birthDate}
						</div>
					</div>
				)}
				{userProfile?.address?.formattedFullAddress && (
					<div className='user-profile-card__body__item'>
						<Text
							className='user-profile-card__body__item__label'
							tx='base.shared.address'
							firstUpper
						/>
						<div className='user-profile-card__body__item__value'>
							{userProfile?.address?.formattedFullAddress}
						</div>
					</div>
				)}
				{userProfile?.insuranceCompanyTermItem?.value &&
					userProfile?.insuranceCompanyTermItem?.value2 && (
						<div className='user-profile-card__body__item'>
							<Text
								className='user-profile-card__body__item__label'
								tx='base.shared.insuranceCompany'
								firstUpper
							/>
							<div className='user-profile-card__body__item__value'>
								{userProfile?.insuranceCompanyTermItem?.value} -{' '}
								{userProfile?.insuranceCompanyTermItem?.value2}
							</div>
						</div>
					)}
				{userProfile?.birthNumber && (
					<div className='user-profile-card__body__item'>
						<Text
							className='user-profile-card__body__item__label'
							tx='base.shared.insuranceNumber'
							firstUpper
						/>
						<div className='user-profile-card__body__item__value'>
							{userProfile?.birthNumber}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default UserFamilyMemberInvitation;
